<div class="form-group" *ngIf="checkViewMode('edit')">
  <label for="">
    <span class="red-text">{{ getTitle() }} </span>
    <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info" [popover]="getOptionByKey(attribute,'tooltip')"
      placement="right"
      container="body"
      triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>
  <ng-select
    [items]="filteredValues"
    [disabled]="getOptionByKey(attribute,'disabled', 'false')"
    [required]="getOptionByKey(attribute,'required', 'false')"
    bindValue="key"
    bindLabel="value"
    [tabindex]="getOptionByKey(attribute,'tabIndex')"
    placeholder="{{ placeholder }}"
    (change)="onSelectChanged()"
    [(ngModel)]="attribute.value"
    (search)="onSearch($event)">
  </ng-select>
</div>
<div class="" *ngIf="checkViewMode('view')">
  <p><span>{{ getTitle() }}: </span> {{ getValue() }}</p>
</div>